var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKudosCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 17.5H5.66663V6.66668L11.5 0.833344L12.5416 1.87501C12.6388 1.97223 12.7188 2.10418 12.7816 2.27084C12.8438 2.43751 12.875 2.59723 12.875 2.75001V3.04168L11.9583 6.66668H16.5C16.9444 6.66668 17.3333 6.83334 17.6666 7.16668C18 7.50001 18.1666 7.8889 18.1666 8.33334V10C18.1666 10.0972 18.1561 10.2014 18.135 10.3125C18.1144 10.4236 18.0833 10.5278 18.0416 10.625L15.5416 16.5C15.4166 16.7778 15.2083 17.0139 14.9166 17.2083C14.625 17.4028 14.3194 17.5 14 17.5ZM3.99996 6.66668V17.5H0.666626V6.66668H3.99996Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKudosCount);
export default __webpack_public_path__ + "static/media/kudosCount.25005206856c592f6bfc13e5b77dc897.svg";
export { ForwardRef as ReactComponent };